import type { AnnouncementItem } from '@overlayqa/shared';

/**
 * Announcements whose CTA points at our own Chrome Web Store listing are
 * install prompts. Hide them from the in-app notification bell: the dashboard
 * surfaces "install the extension" via dedicated UI (ExtensionInstallCard /
 * onboarding), and an existing user should not get a permanent unread red dot
 * for a never-expiring "download the extension" tip.
 *
 * Mirrors the extension poller's filter in
 * packages/extension/src/background/announcementPoller.ts — keep the prefix in
 * sync across both surfaces.
 */
export const CWS_SELF_URL_PREFIX = 'chromewebstore.google.com/detail/overlayqa/';

export function filterInstallAnnouncements(announcements: AnnouncementItem[]): AnnouncementItem[] {
  return announcements.filter((a) => !a.ctaUrl || !a.ctaUrl.includes(CWS_SELF_URL_PREFIX));
}
